const ComingSoon = ()=>{

    return (
        <div className='flex flex-1 items-center justify-center' >
            <p className="text-3xl text-gray-400 italic" >Coming Soon...</p>
        </div>
    )
}

export default ComingSoon